const EVENT_BASE = 'sahne:';

export const EVENT_READY = `${EVENT_BASE}ready`;

/**
 * ビューの更新
 */
export const EVENT_UPDATE_VIEW = `${EVENT_BASE}updateView`;

/**
 * ビューの更新イベント
 */
export const EVENT_UPDATE_VIEW_EVENTS = ['DOMContentLoaded', EVENT_UPDATE_VIEW];


/**
 * スクロールロックのイベント
 */
export const EVENT_SCROLL_LOCK_ON_DISABLE_START = `${EVENT_BASE}scroll-lock:onDisableStart`;
export const EVENT_SCROLL_LOCK_ON_DISABLE = `${EVENT_BASE}scroll-lock:onDisable`;
export const EVENT_SCROLL_LOCK_ON_ENABLE_START = `${EVENT_BASE}scroll-lock:onEnableStart`;
export const EVENT_SCROLL_LOCK_ON_ENABLE = `${EVENT_BASE}scroll-lock:onEnable`;